export const VehiclesResource = {
  name: "Vehicles",
  path: "/fleets/vehicles",
  access: ["read-vehicles"],
};
